import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/fn/number/is-integer';
import 'core-js/fn/string/includes';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './App.scss';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import setAuthToken from './utils/setAuthToken'
import { Provider } from 'react-redux'
import './config/httpConfig'
import store from './store'

if(sessionStorage.getItem("auth-token")){
    setAuthToken(sessionStorage.getItem("auth-token"));
}

ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider>
, document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js